import { updateShapeSize } from '../../actions/CurrentSlideActions';
import storeManager from '../../store/StoreManager';
import saveManager from "./SaveManager";

const multiTouchUtils = {
    initialZoomLine: -1,
    initialCenter: undefined,
    initialBounds: undefined,
    previousBounds: undefined,
    isResizing: false,

    zoom(event, shapeModel, refreshShape, updateZoomProperties = undefined) {
        this.isResizing = true;

        if (this.initialZoomLine == -1) {
            this.initialZoomLine = this.getZoomLine(event);
            this.initialCenter = {x: shapeModel.x + shapeModel.width / 2, y: shapeModel.y + shapeModel.height / 2};
            this.initialBounds = {x: shapeModel.x, y: shapeModel.y, width: shapeModel.width, height: shapeModel.height};
            return;
        }

        if (!updateZoomProperties && this.previousBounds) {
            storeManager.getStore().dispatch(updateShapeSize(
                shapeModel.uuid,
                this.previousBounds.width,
                this.previousBounds.height,
                this.previousBounds.x,
                this.previousBounds.y,
                shapeModel.horizontalFlip,
                shapeModel.verticalFlip
            ));

            if (refreshShape)
                refreshShape();

            saveManager.isContentChanged(true);

            return;
        }

        var currentZoomLine = this.getZoomLine(event);
        var offSet = currentZoomLine - this.initialZoomLine;

        var newBounds = {};
        newBounds.width = this.initialBounds.width + offSet;
        newBounds.height = newBounds.width * this.initialBounds.height / this.initialBounds.width;

        if (this.isValidSize(newBounds.width, newBounds.height)){
            newBounds.x = this.initialCenter.x - newBounds.width / 2;
            newBounds.y = this.initialCenter.y - newBounds.height / 2;

            var properties = {};
            properties.scaleX = newBounds.width / this.initialBounds.width;
            properties.scaleY = newBounds.height / this.initialBounds.height;
            properties.translationX = newBounds.x - this.initialBounds.x;
            properties.translationY = newBounds.y - this.initialBounds.y;

            if (updateZoomProperties)
                updateZoomProperties(properties);

            this.previousBounds = newBounds;
        }
    },
    endZoom() {
        this.isResizing = false;
        this.initialZoomLine = -1;
    },
    isValidSize(newWidth, newHeight) {
        var minSize = 30;

        if (newWidth < minSize || newHeight < minSize) {
            return false;
        } else
            return true;
    },
    isMultiTouch(event) {
        if (event.clientX != undefined) { // is MouseEvent
            return false;
        } else {
            if (event.touches.length > 1 || event.changedTouches.length > 1)
                return true;
        }

        return false;
    },
    getZoomLine(event) {
        var touches = this.getTouchPoints(event);

        if (touches.length >= 2) {
            return this.distanceBetweenTwoPoints(touches[0], touches[1]);
        } else
            return -1;
    },
    getTouchPoints(event) {
        if (event.touches && event.touches.length > 1)
            return [{x: event.touches[0].clientX, y: event.touches[0].clientY} , {x: event.touches[1].clientX, y: event.touches[1].clientY}];
        else
        if (event.changedTouches && event.changedTouches.length > 1)
            return [{x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY}, {x: event.changedTouches[1].clientX, y: event.changedTouches[1].clientY}];

        return [];
    },
    distanceBetweenTwoPoints(point1, point2) {
        if (!point1 || !point2)
            return 0;

        return Math.sqrt((point1.x - point2.x) * (point1.x - point2.x) + (point1.y - point2.y) * (point1.y - point2.y));
    }
};

export default multiTouchUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/MultiTouchUtils.js
 **/